<template>
  <div class="agreement">
    <mt-header fixed title="恒信通注册协议" class="title">
      <mt-button slot="left" icon="back" @click="backClickHandler">返回</mt-button>
    </mt-header>
    <div v-html="hasNameAgreementText"></div>
  </div>
</template>

<script>
/* global PUBLIC_APP_NAME, PUBLIC_AGREEMENT_TEXT */

export default {
  name: 'Agreement',
  data() {
    return {
      appName: PUBLIC_APP_NAME,
      agreementText: PUBLIC_AGREEMENT_TEXT,
    };
  },
  computed: {
    hasNameAgreementText() {
      return this.agreementText.replace(/tmpCustomAppName/g, this.appName);
    },
  },
  methods: {
    backClickHandler() {
      if (this.$route.query.pName && this.$route.query.pName === 'register') this.$router.go(-1);
      else window.location.href = 'protocol://android';
    },
  },
};
</script>
